import { ThemeProvider } from '@mui/material/styles'
import { useMemo } from 'react'

import {
  themeAelia,
  themeCentraleDpharma,
  themeCentraleMediprix,
  themeCos,
  themeGcapPharma,
  themeLesOfficinales,
  themePharmacologyStore,
  themeOutremer,
  themeStore,
  themeViatris,
  themeHelloPharmacie,
  themeNormandiePharma,
  themeTrenteSeptDegres,
} from '@/src/theme'

const themes = profile => {
  // Vérification des groupes
  if (profile?.groupAeliaStore) return themeAelia
  if (profile?.groupGcapPharma) return themeGcapPharma
  if (profile?.groupLesOfficinales) return themeLesOfficinales
  if (profile?.groupCos) return themeCos
  if (profile?.groupCentraleMediprix) return themeCentraleMediprix
  if (profile?.groupPharmacologyStore) return themePharmacologyStore
  if (profile?.groupCentraleDpharma) return themeCentraleDpharma
  if (profile?.groupHelloPharmacie) return themeHelloPharmacie
  if (profile?.groupNormandiePharma) return themeNormandiePharma
  if (profile?.group37Degres) return themeTrenteSeptDegres
  if (profile?.viatris) return themeViatris

  return themeStore
}

const ThemeProviderByProfile = ({ profile, children }) => {
  const theme = useMemo(() => {
    return themes(profile)
  }, [
    profile?.groupOutreMer,
    profile?.groupAeliaStore,
    profile?.groupGcapPharma,
    profile?.groupLesOfficinales,
    profile?.groupCos,
    profile?.groupCentraleMediprix,
    profile?.groupPharmacologyStore,
    profile?.groupCentraleDpharma,
    profile?.groupHelloPharmacie,
    profile?.groupNormandiePharma,
    profile?.group37Degres,
    profile?.viatris,
  ])

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default ThemeProviderByProfile
